import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";

import RadialChart1 from "./userpanelChart1";
import RadialChart2 from "./userpanelChart2";
import RadialChart3 from "./userpanelChart3";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const UserPanel = () => {
  const state = useSelector((state) => state);
  return (
    <React.Fragment>
      <Row>
        <Col xl={6} sm={12}>
          <Link to="/apple-id">
            <Card>
              <CardBody>
                <div className="d-flex text-muted">
                  <div className="flex-shrink-0 me-3 align-self-center">
                    <div id="radialchart-1" className="apex-charts" dir="ltr">
                      <RadialChart1
                        pres={Math.floor(state.login?.user.soldPercentage)}
                      />
                    </div>
                  </div>

                  <div className="flex-grow-1 overflow-hidden  align-self-center">
                    <p className="mb-1">Apple IDs With Info</p>
                    <h5 className="">
                      Unsold Accounts:{" "}
                      {state.login?.user.ApplesCount -
                        state.login?.user.ApplesSoldCount}
                    </h5>
                    <h5 className="mb-3">
                      Sold Accounts: {state.login?.user.ApplesSoldCount}
                    </h5>
                    <p className="text-truncate mb-0"></p>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Link>
        </Col>
        <Col xl={6} sm={12}>
          <Link to="/apple-q">
            <Card>
              <CardBody>
                <div className="d-flex text-muted">
                  <div className="flex-shrink-0 me-3 align-self-center">
                    <div id="radialchart-1" className="apex-charts" dir="ltr">
                      <RadialChart1
                        pres={Math.floor(state.login?.user.soldPercentageq)}
                      />
                    </div>
                  </div>

                  <div className="flex-grow-1 overflow-hidden  align-self-center">
                    <p className="mb-1">Apple IDs With Questions</p>
                    <h5 className="">
                      Unsold Accounts:{" "}
                      {state.login?.user.ApplesCountq -
                        state.login?.user.ApplesSoldCountq}
                    </h5>
                    <h5 className="mb-3">
                      Sold Accounts: {state.login?.user.ApplesSoldCountq}
                    </h5>
                    <p className="text-truncate mb-0"></p>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Link>
        </Col>

        <Col xl={6} sm={12}>
          <Link to="/google">
            <Card>
              <CardBody>
                <div className="d-flex text-muted">
                  <div className="flex-shrink-0 me-3 align-self-center">
                    <div id="radialchart-1" className="apex-charts" dir="ltr">
                      <RadialChart1
                        pres={Math.floor(
                          state.login?.user.soldPercentageGoogle
                        )}
                      />
                    </div>
                  </div>

                  <div className="flex-grow-1 overflow-hidden  align-self-center">
                    <p className="mb-1">Google IDs </p>
                    <h5 className="">
                      Unsold Accounts:{" "}
                      {state.login?.user.GoogleCount -
                        state.login?.user.GoogleSoldCount}
                    </h5>
                    <h5 className="">
                      Sold Accounts: {state.login?.user.GoogleSoldCount}
                    </h5>
                    <p className="text-truncate mb-0"></p>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Link>
        </Col>

        <Col xl={6} sm={12}>
          <Link to="/facebook">
            <Card>
              <CardBody>
                <div className="d-flex text-muted">
                  <div className="flex-shrink-0 me-3 align-self-center">
                    <div id="radialchart-1" className="apex-charts" dir="ltr">
                      <RadialChart1
                        pres={Math.floor(
                          state.login?.user.soldPercentageFacebook
                        )}
                      />
                    </div>
                  </div>

                  <div className="flex-grow-1 overflow-hidden  align-self-center">
                    <p className="mb-1">Facebook IDs </p>
                    <h5 className="">
                      Unsold Accounts:{" "}
                      {state.login?.user.FacebookCount -
                        state.login?.user.FacebookSoldCount}
                    </h5>
                    <h5 className="mb-3">
                      Sold Accounts Number:{" "}
                      {state.login?.user.FacebookSoldCount}
                    </h5>
                    <p className="text-truncate mb-0"></p>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Link>
        </Col>

        <Col xl={6} sm={12}>
          <Link to="/instagram">
            <Card>
              <CardBody>
                <div className="d-flex text-muted">
                  <div className="flex-shrink-0 me-3 align-self-center">
                    <div id="radialchart-1" className="apex-charts" dir="ltr">
                      <RadialChart1
                        pres={Math.floor(
                          state.login?.user.soldPercentageInstagram
                        )}
                      />
                    </div>
                  </div>

                  <div className="flex-grow-1 overflow-hidden  align-self-center">
                    <p className="mb-1">Instagram IDs </p>
                    <h5 className="">
                      Unsold Accounts:{" "}
                      {state.login?.user.InstagramCount -
                        state.login?.user.InstagramSoldCount}
                    </h5>

                    <h5 className="mb-3">
                      Sold Accounts: {state.login?.user.InstagramSoldCount}
                    </h5>
                    <p className="text-truncate mb-0"></p>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Link>
        </Col>

        <Col xl={6} sm={12}>
          <Link to="/snapchat">
            <Card>
              <CardBody>
                <div className="d-flex text-muted">
                  <div className="flex-shrink-0 me-3 align-self-center">
                    <div id="radialchart-1" className="apex-charts" dir="ltr">
                      <RadialChart1
                        pres={Math.floor(
                          state.login?.user.soldPercentageSnapchat
                        )}
                      />
                    </div>
                  </div>

                  <div className="flex-grow-1 overflow-hidden  align-self-center">
                    <p className="mb-1">Snapchat IDs </p>
                    <h5 className="">
                      Unsold Accounts:{" "}
                      {state.login?.user.SnapchatCount -
                        state.login?.user.SnapchatSoldCount}
                    </h5>
                    <h5 className="mb-3">
                      Sold Accounts: {state.login?.user.SnapchatSoldCount}
                    </h5>
                    <p className="text-truncate mb-0"></p>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Link>
        </Col>

        <Col xl={6} sm={12}>
          <Link to="/playstation">
            <Card>
              <CardBody>
                <div className="d-flex text-muted">
                  <div className="flex-shrink-0 me-3 align-self-center">
                    <div id="radialchart-1" className="apex-charts" dir="ltr">
                      <RadialChart1
                        pres={Math.floor(
                          state.login?.user.soldPercentagePlaystation
                        )}
                      />
                    </div>
                  </div>

                  <div className="flex-grow-1 overflow-hidden  align-self-center">
                    <p className="mb-1">Playstation IDs </p>
                    <h5 className="">
                      Unsold Accounts:{" "}
                      {state.login?.user.PlaystationCount -
                        state.login?.user.PlaystationSoldCount}
                    </h5>

                    <h5 className="mb-3">
                      Sold Accounts: {state.login?.user.PlaystationSoldCount}
                    </h5>
                    <p className="text-truncate mb-0"></p>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Link>
        </Col>

        <Col xl={6} sm={12}>
          <Link to="/applesms">
            <Card>
              <CardBody>
                <div className="d-flex text-muted">
                  <div className="flex-shrink-0 me-3 align-self-center">
                    <div id="radialchart-1" className="apex-charts" dir="ltr">
                      <RadialChart1
                        pres={Math.floor(
                          state.login?.user.soldPercentageAppleSms
                        )}
                      />
                    </div>
                  </div>

                  <div className="flex-grow-1 overflow-hidden  align-self-center">
                    <p className="mb-1">Apple Sms IDs </p>
                    <h5 className="">
                      Unsold Accounts:{" "}
                      {state.login?.user.AppleSmsCount -
                        state.login?.user.AppleSmsSoldCount}
                    </h5>
                    <h5 className="mb-3">
                      Sold Accounts: {state.login?.user.AppleSmsSoldCount}
                    </h5>
                    <p className="text-truncate mb-0"></p>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Link>
        </Col>

        <Col xl={6} sm={12}>
          <Link to="/apple-qr">
            <Card>
              <CardBody>
                <div className="d-flex text-muted">
                  <div className="flex-shrink-0 me-3 align-self-center">
                    <div id="radialchart-1" className="apex-charts" dir="ltr">
                      <RadialChart1
                        pres={Math.floor(state.login?.user.soldPercentageQr)}
                      />
                    </div>
                  </div>

                  <div className="flex-grow-1 overflow-hidden  align-self-center">
                    <p className="mb-1">Apple Qr IDs </p>
                    <h5 className="">
                      Unsold Accounts:{" "}
                      {state.login?.user.ApplesCountQr -
                        state.login?.user.ApplesSoldCountQr}
                    </h5>
                    <h5 className="mb-3">
                      Sold Accounts: {state.login?.user.ApplesSoldCountQr}
                    </h5>
                    <p className="text-truncate mb-0"></p>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Link>
        </Col>

        <Col xl={6} sm={12}>
          <Link to="/google-qr">
            <Card>
              <CardBody>
                <div className="d-flex text-muted">
                  <div className="flex-shrink-0 me-3 align-self-center">
                    <div id="radialchart-1" className="apex-charts" dir="ltr">
                      <RadialChart1
                        pres={Math.floor(
                          state.login?.user.soldPercentageGoogleQr
                        )}
                      />
                    </div>
                  </div>

                  <div className="flex-grow-1 overflow-hidden  align-self-center">
                    <p className="mb-1">Google Qr IDs </p>
                    <h5 className="">
                      Unsold Accounts:{" "}
                      {state.login?.user.GooglesCountQr -
                        state.login?.user.GooglesSoldCountQr}
                    </h5>
                    <h5 className="mb-3">
                      Sold Accounts: {state.login?.user.GooglesSoldCountQr}
                    </h5>
                    <p className="text-truncate mb-0"></p>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Link>
        </Col>
        {/* <Col xl={6} sm={12}>
          <Link to="/nfc-card">
            <Card>
              <CardBody>
                <div className="d-flex">
                  <div className="flex-shrink-0 me-3 align-self-center">
                    <RadialChart2
                      id="radialchart-2"
                      className="apex-charts"
                      dir="ltr"
                    />
                  </div>

                  <div className="flex-grow-1 overflow-hidden  align-self-center">
                    <p className="mb-1">NFC Cards</p>
                    <h5 className="mb-3">Cards: 1400</h5>
                    {/* <p className="text-truncate mb-0">
                    <span className="text-success me-2">
                      {" "}
                      1.7%{" "}
                      <i className="ri-arrow-right-up-line align-bottom ms-1"></i>
                    </span>{" "}
                    From previous
                  </p> 
                  </div>
                </div>
              </CardBody>
            </Card>
          </Link>
        </Col> */}
      </Row>
    </React.Fragment>
  );
};

export default UserPanel;
